import {formattedTime} from './helpers';
import EditableField from '../../common/fields/EditableField';
import {EditableFieldProps, TargetTimeSettingsResponseProps} from './types';
import {convertTimeInSeconds} from './helpers';
import {
  processTimeWithHoursValidationSchema,
  processTimeWithoutHoursValidationSchema
} from '../../../constants/validationSchemes';
import {maxProcessTimeInSeconds, ProcessTypeLabelsMap} from '../alert_alarm/constants';
import {Dispatch, SetStateAction} from 'react';
import {updateProcessTimeSettings, getTargetTimeSettings} from '../../../api/settings/target_task_time/index';
import * as yup from 'yup';
import {useTranslation} from 'react-i18next';
import {useSnackbarHook} from '../../../hooks/useSnackbar';

type TargetProcessTimeProps = {
  processTargetTime?: number,
  processType?: string,
  isVisibleTreatments: boolean,
  treatmentId: string,
  setTargetTimeSettings:
    Dispatch<TargetTimeSettingsResponseProps> | Dispatch<SetStateAction<null>>,
  setIsTaskTimeChanged: Dispatch<boolean>,
  setIsShowDraftVersion: Dispatch<boolean>,
}

const initialTouched = {
  hours: true,
  minutes: true
};

const TargetProcessTime: React.FC<TargetProcessTimeProps> = ({
  processTargetTime = 0,
  processType = '',
  isVisibleTreatments,
  treatmentId,
  setTargetTimeSettings,
  setIsTaskTimeChanged,
  setIsShowDraftVersion
}) => {
  const {t} = useTranslation('targetTaskTime');
  const {addSuccessToast, addErrorToast} = useSnackbarHook();

  const handleUpdate = async (
      ediTableFieldValue: EditableFieldProps
  ) => {
    let timeInSeconds = convertTimeInSeconds(
        {
          hours: ediTableFieldValue.hours,
          minutes: ediTableFieldValue.minutes,
          seconds: ediTableFieldValue.seconds
        }
    );

    timeInSeconds = timeInSeconds > maxProcessTimeInSeconds ?
    maxProcessTimeInSeconds : timeInSeconds;

    const treatmentIdParams = isVisibleTreatments ? treatmentId : '';

    try {
      await updateProcessTimeSettings(
          processType, treatmentIdParams, timeInSeconds
      );
      const process = ProcessTypeLabelsMap[processType];
      addSuccessToast(t('toasts.updateProcessTimeMessage', {process}));
      const targetTimeSettingsResponse =
        await getTargetTimeSettings(processType, treatmentIdParams);

      setTargetTimeSettings(targetTimeSettingsResponse);
      setIsTaskTimeChanged(true);
      setIsShowDraftVersion(true);
    } catch (error) {
      addErrorToast(error?.message);
    }
  };

  const {hours, minutes, seconds} =
    formattedTime(processTargetTime, true);

  const cellItem = {
    rowId: 0,
    cellData: {hours: hours, minutes: minutes, seconds: seconds},
    editHandler: async (id, value) => handleUpdate(value),
    permission: null
  };

  const validationSchema = () => yup.lazy((values) => {
    if (values?.hours && +values.hours === 0 && +values.minutes > 0) {
      return processTimeWithoutHoursValidationSchema;
    }

    return processTimeWithHoursValidationSchema;
  });

  return (
    <div className="target-process">
      <span className="title">
        {t('targetProcessTime')}
      </span>
      <div className="field">
        <EditableField
          cellItem={cellItem}
          separator={' : '}
          validationSchema={validationSchema()}
          initialTouched={initialTouched}
          isTimeInput
        />
      </div>
    </div>
  );
};

export default TargetProcessTime;
